import moment from "moment";

export const getFormattedUTCDate = (
  date: Date | string | undefined,
  format: string
) => {
  return moment.utc(date).format(format);
};
